// utils/analytics.ts
import posthog from 'posthog-js';

const posthogKey = process?.env?.NEXT_PUBLIC_POSTHOG_KEY;
export function initPosthog() {
    posthog.init(posthogKey!, {
        api_host: '/ingest',
        ui_host: 'https://us.posthog.com',
        capture_exceptions: true,
        loaded: (ph) => {
          if (process.env.NODE_ENV === 'development') ph.debug()
        },
        debug: process.env.NODE_ENV === 'development',
      })
}

export function trackPostHogEvent(
  name: string,
  properties?: Record<string, any>
): void {
  if (typeof window !== 'undefined' && posthog) {
    posthog.capture(name, properties)
  }
}